import { CancelToken } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODCreateResponse, IVODRequestParams } from '~/Models/DTO/VideoOnDemand.models';
import { routeReplacer } from '~/Helpers/String.helper';

export const useRequestPatchVOD = (cancelToken?: CancelToken) => {
  const queryClient = useQueryClient();
  const {
    data: vodUpdateResponse,
    error: vodUpdateError,
    isLoading: isVodVideoUpdateLoading,
    mutate: updateVideo,
    isSuccess: isVodVideoUpdateSuccess,
  } = useMutation<IVODCreateResponse, IErrorResponse, IVODRequestParams>(
    async (params: IVODRequestParams) =>
      requestReactQuery<IVODCreateResponse>({
        url: routeReplacer(VIDEO_INTEGRATION_SERVICE_URLS.VOD_GET_VIDEO, {
          videoId: params?.id || '',
        }),
        data: {
          releaseDate:
            params?.state === 'online' ? params?.releaseDate || new Date().toISOString() : null,
          categoryId: params?.categoryId,
          descriptions: params?.descriptions,
          forwardToBookingTool: false,
          forwardToUSC: true,
          language: params?.language,
          name: params?.name,
          productIds: params?.productIds,
          filename: params?.filename,
          providerId: params?.providerId,
          thumbnailPosition: params?.thumbnailPosition,
          trainerIds: params?.trainerIds,
        },
        config: { method: 'PATCH', cancelToken },
      }),
    {
      mutationKey: REQUEST_ACTIONS.GET_VOD_VIDEOS,
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: [REQUEST_ACTIONS.GET_VOD_VIDEOS] }),
    },
  );

  return {
    vodUpdateError: vodUpdateError as IErrorResponse,
    vodUpdateResponse,
    updateVideo,
    isVodVideoUpdateLoading,
    isVodVideoUpdateSuccess,
  };
};
